import React from "react";
import styles from "../styles/modal.module.css";

const CustomModal = ({ message, buttonText = "OK", onConfirm }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <p>{message}</p>
        <button onClick={onConfirm} className={styles.confirmButton}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default CustomModal;
